import React, { useState } from 'react'
import "../../components/dataTable/datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import useFetch from '../../hooks/useFetch'
import { useEffect } from 'react';
import { axiosInstance } from '../../config';
import Spinner from '../../components/spinner';
import "../carouselEntries/carousel.scss"

const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 200,
    },
    {
        field: 'imgUrl',
        headerName: 'Image Link',
        width: 150,
        renderCell: (params) => (
            <a href={params.value} target="_blank" rel="noopener noreferrer">
                {params.value}
            </a>
        ),
    },
    {
        field: 'content1',
        headerName: 'Content 1',
        width: 320
    },
    {
        field: 'content2',
        headerName: 'Content 2',
        width: 320
    },
];

const TeacherEntries = () => {

    const [list, setList] = useState();
    const [loading, setLoading] = useState(true);
    const { data } = useFetch("/teacher-entry/")
    const [info, setInfo] = useState();
    
    useEffect(() => {
        setList(data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        setLoading(false);
    },[data])

    const handleDelete = async (id) => {
        try{
            await axiosInstance.delete(`/teacher-entry/${id}`)
            setList(list.filter((item) => item._id !== id))
        }catch(err){
            console.log(err);
        }
    }

    const handleChange = (e) => {
        e.preventDefault();
        setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };
    
    const handleCreate = async () => {
        try{
            await axiosInstance.post(`/teacher-entry/`, info);
            setInfo({});
            alert("Teacher entry created!");
        }catch(err){
            console.log(err);
        }
    }

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 150,
            renderCell: (params)=>{
                return(
                    <div className='cellAction'>
                        <div className='deleteBtn' onClick={() => handleDelete(params.row._id)}>DELETE</div>
                    </div>
                )
            }
        }
    ]
  return (
    <div className='carousel-wrapper'>  
        <div className='create-box'>
        <form className="createForm">
                <h3>Create a New Teacher Entry</h3>
                <div className="formItem">
                  <label>Name <span>(required)</span></label>
                  <input
                    type="textarea"
                    id = "name"
                    onChange={handleChange}
                    placeholder="Shresth Dagar"
                    className="formInput"
                    required
                  />
                </div>
                <div className="formItem">
                  <label>Content line 1 <span>(required)</span></label>
                  <input
                    type="textarea"
                    id = "content1"
                    onChange={handleChange}
                    placeholder="Mathematics"
                    className="formInput"
                    required
                  />
                </div>
                <div className="formItem">
                  <label>Content line 2<span>(optional)</span></label>
                  <input
                    type="textarea"
                    id = "content2"
                    onChange={handleChange}
                    placeholder="JEE/NDA/CUET"
                    className="formInput"
                  />
                </div>
                <div className="formItem">
                  <label>Image URL <span>(required)</span></label>
                  <input
                    type="textarea"
                    id = "imgUrl"
                    onChange={handleChange}
                    placeholder="https://xyz.com/image"
                    className="formInput"
                    required
                  />
                </div>
                <button className="formCreateButton" onClick={() => handleCreate()}>Create</button>
            </form>
            <div className='instructions'>
                <p><b>Instructions - </b></p>
                <p>1. Double check the URLs before adding.</p>
                <p>2. Name and Content are the texts you'll see in live webiste.</p>
                <p>3. Please enter '#' in Image URL if you want it to show placeholder.</p>
            </div>
        </div>
        <div className='data-table'>
            {
                loading && <Spinner/>
            }
            
            { !loading && <DataGrid
                className='dataGrid'
                rows = {list}
                columns={columns.concat(actionColumn)}
                pageSize={8}
                rowsPerPageOptions={[8]}
                getRowId={row => row._id}
            />}
        </div>
    </div>
  )
}

export default TeacherEntries
